import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15.02 19.52c-2.34 .736 -5 .606 -7.32 -.52l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.96 1.671 2.898 3.963 2.755 6.227","key":"svg-0"}],["path",{"d":"M19 16v3","key":"svg-1"}],["path",{"d":"M19 22v.01","key":"svg-2"}]]

const IconMessageCircleExclamation = createReactComponent('outline', 'message-circle-exclamation', 'MessageCircleExclamation', __iconNode);

export default IconMessageCircleExclamation;